import { useEffect, useState } from "react";
import { MOBILE_SCROLL_MQ } from "@/mobileScrollHub";

/** True when viewport is ≤767px (matches App.js / story-section mobile breakpoint). */
export function useMobileViewport() {
  const [mobile, setMobile] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia(MOBILE_SCROLL_MQ).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_SCROLL_MQ);
    const sync = () => setMobile(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return mobile;
}
